import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import {
  IconBrandAndroid,
  IconBrandApple,
  IconBrandGooglePlay
} from "@tabler/icons-react";
import MxDetailLayoutMain from "@rf-l1/page/details/MxDetailLayoutMain";
import Snap from "@images-rf/snapshop-maxcore-app.webp";

export default function AppMobilePromoPage() {
  const androidUrl = "https://play.google.com/store/apps/details?id=com.maxcoreapp";
  const iosUrl = "https://app.remaxrd.com/";
  const qrUrl = iosUrl || androidUrl || `${window.location.origin}/app-movil`;

  return (
    <MxDetailLayoutMain
      container
      bgcolor={"#fff"}
      minHeight={{ xs: "70vh", md: "86dvh" }}
    >
      <Grid container maxWidth={1000} mx="auto">
        <Grid
          item
          xs={12}
          md={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          mx="auto"
        >
          <Box
            width="100%"
            p={{
              xs: 3,
              md: 0
            }}
            textAlign={{
              xs: "center",
              md: "left"
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
              DESCARGA NUESTRA APP
            </Typography>

            <Typography
              textAlign={"left"}
              variant="body2"
              color="text.secondary"
              sx={{ mb: 3, mt: 1 }}
            >
              Lleva MAXCORE contigo: gestiona propiedades, comparte y mantente al día
              donde estés. Empieza hoy con la app para Android o iOS.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems={{ xs: "stretch", sm: "center" }}
            >
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                alignItems="center"
              >
                <Button
                  variant="contained"
                  size="large"
                  startIcon={<IconBrandApple />}
                  href={iosUrl || undefined}
                  target={iosUrl ? "_blank" : undefined}
                  rel={iosUrl ? "noopener noreferrer" : undefined}
                  disabled={!iosUrl}
                  sx={{
                    borderRadius: 0.3,
                    boxShadow: "none",
                    bgcolor: "#030303",
                    minWidth: 170
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      lineHeight: 1.2,
                      textAlign: "center",
                      fontSize: 12
                    }}
                  >
                    <span style={{ fontWeight: 400 }}>Disponible para </span>
                    <span>dispositivos iOS</span>
                  </Box>
                </Button>

                <Button
                  variant="contained"
                  size="large"
                  startIcon={<IconBrandGooglePlay />}
                  href={androidUrl || undefined}
                  target={androidUrl ? "_blank" : undefined}
                  rel={androidUrl ? "noopener noreferrer" : undefined}
                  disabled={!androidUrl}
                  sx={{
                    borderRadius: 0.3,
                    boxShadow: "none",
                    bgcolor: "primary.main",
                    fontSize: 12,
                    minWidth: 170
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      lineHeight: 1.2
                    }}
                  >
                    <span style={{ fontWeight: 400 }}>Disponible en</span>
                    <span>Google Play</span>
                  </Box>
                </Button>
              </Stack>
            </Stack>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, mt: 2 }}>
              ¿Cómo instalar la app en{" "}
              <a
                style={{
                  textDecoration: "underline",
                  color: "red"
                }}
                href="https://www.youtube.com/watch?v=r2X6y7jkVIk"
              >
                {" "}
                iOS
              </a>{" "}
              o{" "}
              <a
                style={{
                  color: "red",
                  textDecoration: "underline"
                }}
                href="https://www.youtube.com/watch?v=8c-u3iWSU9g"
              >
                Android
              </a>
              ?
            </Typography>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          mx="auto"
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: { xs: 1, md: 0 } }}
        >
          <Box
            sx={{
              position: "absolute",
              width: 280,
              height: 280,
              borderRadius: "50%",
              background: "radial-gradient(circle at 30% 30%, #A855F7, #EC4899)",
              opacity: 0.2,
              filter: "blur(10px)"
            }}
          />
          <Box
            sx={{
              position: "relative",
              width: { xs: 260, sm: 300 },
              height: { xs: 520, sm: 580 },
              borderRadius: 5,
              bgcolor: "#111",
              boxShadow: 6,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Box
              sx={{
                width: "88%",
                height: "92%",
                bgcolor: "primary.light",
                borderRadius: 3,
                display: "grid",
                alignItems: "center",
                justifyItems: "center",
                "& svg": {
                  width: "5rem",
                  height: "7rem"
                },
                overflow: "hidden"
              }}
            >
              <img src={Snap} width="100%" height="100%" />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </MxDetailLayoutMain>
  );
}
